import { formatDisplayNumber } from '#/utils/formatNumber';

const ROUNDING_EPS = 1e-9;

/** FMS 金額顯示：新台幣無小數單位，一律顯示到整數（唯讀 UI；勿用於 payload） */
export function formatFmsAmount(value) {
  return formatDisplayNumber(value, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

/**
 * 依取整方式取到整數（前端試算用）。加 epsilon 避免 0.1+0.2 類浮點誤差。
 * @param {number} value
 * @param {'HALF_UP'|'CEILING'|'FLOOR'} mode
 */
export function roundFmsAmount(value, mode) {
  if (mode === 'CEILING') return Math.ceil(value - ROUNDING_EPS);
  if (mode === 'FLOOR') return Math.floor(value + ROUNDING_EPS);
  return Math.sign(value) * Math.round(Math.abs(value) + ROUNDING_EPS);
}
